import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LogSlice {
  logVisible: boolean;
}
// 預設關閉日誌可見狀態
const initialState: LogSlice = {
  logVisible: false,
};

const logSlice = createSlice({
  name: "log",
  initialState,
  reducers: {
    setLogVisible: (state, action: PayloadAction<boolean>) => {
      state.logVisible = action.payload;
    },
  },
});

export const { setLogVisible } = logSlice.actions;

export default logSlice;
